<template>
  <!-- 用户登录页 - 短信验证码登录 -->
  <div>
    <el-form :model="form" ref="form" :rules="rules" @submit.native.prevent>

      <div class="user-err">
        <zt-tip :msg="userErr" type="error"></zt-tip>
      </div>

      <el-form-item prop="telephone" :error="telephoneErr">
        <el-input placeholder="请输入手机号码" v-model.trim="form.telephone" clearable>
          <svg-icon icon="telephone" slot="prefix" size="24px"/>
        </el-input>
      </el-form-item>

      <el-form-item prop="telephone_code" :error="smsErr">
        <div class="code-input">
          <el-input placeholder="请输入验证码" v-model="form.telephone_code"/>
          <el-button class="code" @click="onGetSmsCode" :disabled="smsDisabled">{{smsBtnText}}</el-button>
        </div>
      </el-form-item>

      <el-form-item class="mb0">
        <el-checkbox v-model="remeberMe">记住我</el-checkbox>
      </el-form-item>

      <zt-button type="primary" :loading="loading" @click.enter.exact="onSubmit" native-type="submit">登录</zt-button>
      <router-link class="register-link" to="/register">暂无账号? 立即注册></router-link>

    </el-form>

    <!-- 图形验证码弹框 -->
    <image-code-dialog
      :visible.sync="imgDialogVisible"
      :telephone="form.telephone"
      @success="onSuccess"
    />

  </div>
</template>

<script>

import ZtTip from '@/components/ZtTip'
import loginMixin from '../mixins/login'
import { countdownSeconds } from '@/utils/timer'
import ImageCodeDialog from './ImageCodeDialog'

export default {
  name: 'SMSLogin',
  components: {
    ZtTip,
    ImageCodeDialog
  },
  mixins: [ loginMixin ],

  data: () => ({
    form: {
      telephone: process.env.VUE_APP_DEV_PHONE || '',
      telephone_code: process.env.VUE_APP_DEV_CODE || '',
    },
    rules: {
      telephone: [ { required: true, message: '请输入手机号码' } ],
      telephone_code: [ { required: true, message: '请输入验证码' } ]
    },

    // el-form-item的错误信息
    telephoneErr: '',
    smsErr: '',

    imgDialogVisible: false,  // 图形验证码弹窗

    // 发送短信
    smsCountdownTimer: null,  // 发送短信倒计时
    smsBtnText: '获取验证码',
    smsDisabled: false,
  }),
  methods: {
    // 登录
    onSubmit() {
      const { form } = this.$refs
      form.validate((valid) => {
        if (valid) {
          this.login({ ...this.form })
        }
      })
    },

    // 获取短信验证码
    onGetSmsCode() {
      const { form } = this.$refs
      // 有手机号码就展示dialog
      form.validateField(['telephone'], (err) => {
        if (!err) {
          this.imgDialogVisible = true
        }
      })
    },

    // 发送验证码成功
    onSuccess() {
      // 倒计时60s
      clearInterval(this.smsCountdownTimer)
      this.smsCountdownTimer = countdownSeconds({
        current: (count) => {
          this.smsBtnText = count
          this.smsDisabled = true
        },
        lastone: () => {
          this.smsDisabled = false
          this.smsBtnText = '获取验证码'
        },
        count: 60
      })
    },

  },
  watch: {
    "form.telephone"(val) {
      if (val.indexOf(" ") !== -1) {
        this.form.telephone = this.form.telephone.replace(/\s+/g, "");
      }
    }
  },

}
</script>

<style lang="scss" scoped>
@import "~@/styles/login.scss";

.el-dialog__wrapper {

  /deep/ .el-dialog__body {
    padding: 26px 16px 18px;

    .dialog-btns {
      text-align: right;
      margin-top: 44px;
    }
    .zt-button {
      width: auto;
    }
  }
}
</style>
